import { render } from "./setDiscountRegion.vue?vue&type=template&id=24253c4a&scoped=true"
import script from "./setDiscountRegion.vue?vue&type=script&lang=js"
export * from "./setDiscountRegion.vue?vue&type=script&lang=js"

import "./setDiscountRegion.vue?vue&type=style&index=0&id=24253c4a&lang=scss"
import "./setDiscountRegion.vue?vue&type=style&index=1&id=24253c4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24253c4a"]])

export default __exports__